import { useEffect, useState, type ReactNode } from 'react'

type Props = {
  title?: string
  children?: ReactNode
}

export default function CustomerLeftSideBar({ title = 'Mục lục sản phẩm', children }: Props) {
  const [isDark, setIsDark] = useState(() => document.documentElement.classList.contains('dark'))

  useEffect(() => {
    const onThemeChanged = (ev: Event) => {
      const nextIsDark = (ev as CustomEvent<{ isDark: boolean }>).detail?.isDark
      if (typeof nextIsDark === 'boolean') setIsDark(nextIsDark)
    }
    window.addEventListener('digigo-theme-changed', onThemeChanged)
    return () => window.removeEventListener('digigo-theme-changed', onThemeChanged)
  }, [])

  return (
    <aside className="hidden lg:block w-72 shrink-0 self-start sticky top-6">
      <div>
        <div
          className="sidebar-surface rounded-2xl shadow-[0_24px_60px_rgba(2,6,23,0.12)] overflow-hidden transition-all duration-200"
          data-testid="customer-left-sidebar"
        >
          <div className="px-4 py-3 border-b border-slate-200/80 dark:border-white/10 flex items-center justify-between">
            <div className="min-w-0">
              <div className="text-sm font-extrabold tracking-wide truncate text-slate-900 dark:text-white">{title}</div>
            </div>
          </div>

          <div className="p-3">
            {children ?? (
              <div className="text-sm text-slate-600 dark:text-slate-400 italic">Chỉ hiển thị khi đang ở trang Sản phẩm.</div>
            )}
          </div>
        </div>

        {/* 2026 Happy New Year Banner */}
        <div className="mt-4 rounded-2xl sidebar-surface shadow-[0_24px_60px_rgba(2,6,23,0.12)] overflow-hidden p-4 flex flex-col items-center text-center">
          <div className="text-4xl font-black text-red-600 drop-shadow-lg leading-none mb-1 animate-pulse">
            2026
          </div>
          <div className="text-lg font-bold text-yellow-500 drop-shadow-md leading-none">
            Happy New Year
          </div>
        </div>
      </div>
    </aside>
  )
}
